import React from 'react';
import ButtonLink from '../../common/TrackedButtonLink';
import LazyLoad from 'react-lazyload';
import { PRODUCT_SELECTOR } from "../../../constants/app";
import {dataLayerPush} from "../../../utils";
import TrackedButtonLink from "../../common/TrackedButtonLink";

const BrowseSafes = () => {
	return (
		<section className="accent-image">
			<LazyLoad once={ true } offset={ 200 }>
				<img
					src={ require('../../../resources/img/hero/safe-closet.jpg') }
					alt="Safe In Closet"
				/>
			</LazyLoad>
			<div className="content">
				<div className="row">
					<div className="col">
						<h2 className="title">
							Find the Safe That&rsquo;s<br /> Right For You
						</h2>
						<div className="row">
							<div className="col sm-6">
								<TrackedButtonLink to={PRODUCT_SELECTOR.URL} target={PRODUCT_SELECTOR.TARGET} id="ctaBrowseSafesProductSelector" className={`btn btn-primary`}>
									{PRODUCT_SELECTOR.TEXT}
								</TrackedButtonLink>
							</div>
							<div className="col sm-6">
								<ButtonLink className="btn-primary" to="/products">
									Browse all safes
								</ButtonLink>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BrowseSafes;


// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/BrowseSafes.js